const styles = {
    container: {
        maxWidth: '100%',
        mt: '24px',
    },
    title: {
        fontFamily: 'Silka_Bold',
        fontWeight: 700,
        fontSize: '32px',
        lineHeight: '48px',
        color: '#090C39',
        textTransform: 'capitalize',
    },
    subTitle: {
        fontFamily: 'Silka_Regular',
        fontWeight: 400,
        fontSize: '24px',
        lineHeight: '36px',
        color: '#8697AB',
    },
    divider: {
        color: '#E0E4ED',
        marginTop: '32px',
        marginBottom: '32px',
    },
};
export default styles;
